const stripProtocol = (value) => value.replace(/^https?:\/\//i, '');
const stripPath = (value) => value.replace(/\/.*$/, '');

export const normalizeHost = (value) => {
  if (!value) return '';
  const trimmed = String(value).trim();
  if (!trimmed) return '';
  return stripPath(stripProtocol(trimmed)).toLowerCase();
};

export const getHostname = () => {
  if (typeof window === 'undefined') return '';
  return String(window.location?.hostname || '').toLowerCase();
};

export const isLocalHostname = (hostname = getHostname()) =>
  /^(localhost|127\.0\.0\.1|0\.0\.0\.0)$/.test(hostname || '');

export const toDomainList = (value) =>
  String(value || '')
    .split(',')
    .map((entry) => normalizeHost(entry))
    .filter(Boolean);

export const hostMatchesDomain = (hostname, domain) => {
  const normalizedHost = normalizeHost(hostname);
  const normalizedDomain = normalizeHost(domain);
  if (!normalizedHost || !normalizedDomain) return false;
  return normalizedHost === normalizedDomain || normalizedHost.endsWith(`.${normalizedDomain}`);
};

export const hostMatchesList = (hostname, domains) =>
  (domains || []).some((domain) => hostMatchesDomain(hostname, domain));

export const getPrimaryDomain = () => {
  const envDomain = normalizeHost(
    process.env.REACT_APP_PRIMARY_DOMAIN || process.env.REACT_APP_BASE_DOMAIN || ''
  );
  if (envDomain) return envDomain;

  const hostname = getHostname();
  if (!hostname || isLocalHostname(hostname)) return hostname;
  const parts = hostname.split('.');
  if (parts.length <= 2) return hostname;
  return parts.slice(-2).join('.');
};
